import React from 'react';
import { graphql, Link } from "gatsby";
import Seo from "../components/includes/seo";
import Layout from "../components/includes/layout";
import { SliceZone, PrismicRichText } from "@prismicio/react";
import { components } from "../components/slices";
import { GatsbyImage, getImage } from "gatsby-plugin-image";



export const resourceQuery = graphql`
query ResourceQuery($id: String) {
    prismicResource(id: {eq: $id}) {
        data {
            body {
              ... on PrismicResourceDataBodyResourceDownload {
                id
                slice_type
                primary {
                  button_label
                  pdf {
                    url
                  }
                }
              }
              ... on PrismicResourceDataBodyResourcePageVideo {
                id
                slice_type
                primary {
                  video
                  video_caption
                }
              }
              ... on PrismicResourceDataBodyResourceQuote {
                id
                slice_type
                primary {
                  quote {
                    richText
                  }
                  quote_author
                  quote_author_title
                  quote_color
                }
                items{
                  quote {
                    richText
                  }
                  quote_author
                  quote_author_title
                }
              }
              ... on PrismicResourceDataBodyResourcePageBlockDetail {
                id
                items {
                  detail_content {
                    richText
                  }
                  detail_label
                  icon {
                    url
                    alt
                  }
                }
                slice_type
                primary {
                  content {
                    richText
                  }
                  custom
                  section_name
                }
              }
              ... on PrismicResourceDataBodyResourcePageBlock {
                id
                items {
                  data_number
                  data_text {
                    richText
                  }
                  theme
                }
                primary {
                  content {
                    richText
                  }
                  custom
                  section_name
                }
                slice_type
              }
              ... on PrismicResourceDataBodyResourcePageHeader {
                id
                primary {
                  brand_logo {
                    alt
                    gatsbyImageData(placeholder: NONE)
                  }
                  theme
                }
                slice_type
              }
              ... on PrismicResourceDataBodyCard {
              id
              slice_type
              items {
                resource {
                  type
                  document {
                    ... on PrismicNavigationInsider {
                      url
                      id
                      type
                      data {
                        resource_title {
                          richText
                          text
                        }
                        resource_label
                        date_published(formatString: "MMMM DD, YYYY")
                        description {
                          text
                        }
                        meta_image {
                          gatsbyImageData(layout: CONSTRAINED)
                          alt
                        }
                      }
                    }
                    ... on PrismicPressRelease {
                      id
                      url
                      type
                      data {
                        resource_title {
                          richText
                          text
                        }
                        resource_label
                        date_published(formatString: "MMMM DD, YYYY")
                        description {
                          text
                        }
                        meta_image {
                          gatsbyImageData(layout: CONSTRAINED)
                          alt
                        }
                      }
                    }
                    ... on PrismicResource {
                      url
                      id
                      _previewable
                      data {
                        resource_type
                        resource_title {
                          richText
                          text
                        }
                        resource_label
                        description {
                          text
                        }
                        meta_image {
                          gatsbyImageData(layout: CONSTRAINED)
                          alt
                        }
                      }
                    }
                  }
                }
                button_label
                card_content_type
                card_label
                custom_content{
                  richText
                  text
                }
                resource_type
                custom_image {
                  gatsbyImageData(layout: CONSTRAINED)
                  alt
                  url
                }
                custom_title
                theme
                custom_link {
                  url
                  target
                }
              }
              primary {
                background
                card_layout
                spacing
                box
                box_background
                card_slider
                section_title {
                  richText
                  text
                }
                section_content {
                  richText
                  text
                }
              }
              }
              ... on PrismicResourceDataBodyVideo {
                id
                items {
                  speaker_company
                  speaker_image {
                    alt
                    gatsbyImageData(layout: CONSTRAINED)
                  }
                  speaker_name
                  speaker_title
                }
                primary {
                  theme
                  video
                  subtitle {
                    richText
                    text
                  }
                  content {
                    text
                    richText
                  }
                }
                slice_type
              }
                ... on PrismicResourceDataBodyEvent {
                    id
                    slice_type
                    items {
                      event_button_label
                      event_button_link {
                        url
                      }
                    }
                    primary {
                      content {
                        richText
                      }
                      event_location
                      event_cta_title
                      hide_event_button
                      type_of_form
                      theme
                      form
                      custom
                    }
                  }
                ... on PrismicResourceDataBodyWebinar {
                    id
                    items {
                      speaker_company
                      speaker_image {
                        alt
                        gatsbyImageData(layout: CONSTRAINED)
                      }
                      speaker_name
                      speaker_title
                    }
                    slice_type
                    primary {
                      content {
                        richText
                      }
                      webinar_title
                      event_button_label
                      event_time
                      event_button_link {
                        url
                      }
                      form
                      custom
                      layout
                      theme
                      webinar_time
                    }
                  }
                ... on PrismicResourceDataBodyGated {
                    id
                    slice_type
                    primary {
                      content {
                        richText
                      }
                      form
                      theme
                      type_of_content
                    }
                  }
                ... on PrismicResourceDataBodyUngated {
                    id
                    slice_type
                    primary {
                        button_label
                        button_link {
                            url
                        }
                        content {
                            richText
                        }
                        custom
                        theme
                        type_of_content
                }
              }
            }
            description {
              text
            }
            date(formatString: "MMMM D, YYYY")
            meta_image {
              alt
              gatsbyImageData(layout: CONSTRAINED)
              url
            }
            title {
              text
            }
            resource_title{
                richText
                text
            }
            resource_label
            resource_type
            hide
            hide_related
            hide_the_date
          }
        url
        tags
    }
    prismicHeaderCallout {
        _previewable
        data {
          label {
            text
          }
          link {
            text
          }
          title {
            richText
          }
        }
      }
    prismicNavigation {
        _previewable
        id
        data {
          entry
          main_nav_items {
            nav_link {
              url
            }
            nav_label
            resource {
              document {
                ... on PrismicPressRelease {
                  id
                  data {
                    resource_title {
                      text
                      richText
                    }
                    description {
                      text
                    }
                    meta_image {
                      gatsbyImageData
                      alt
                    }
                  }
                  url
                }
                ... on PrismicResource {
                    id
                    data {
                      resource_title {
                        text
                        richText
                      }
                      description {
                        text
                      }
                      meta_image {
                        gatsbyImageData
                        alt
                      }
                    }
                    url
                  }
              }
            }
            drop_down {
              id
              document {
                ... on PrismicNavigationItem {
                  id
                  data {
                    theme
                    sub_nav_item {
                      icon {
                        alt
                        gatsbyImageData(layout: CONSTRAINED)
                        url
                      }
                      nav_context{
                        text
                        richText
                      }
                      nav_label
                      sub_nav {
                        document {
                          ... on PrismicSubNavigationItem {
                            id
                            data {
                              sub_nav_item {
                                nav_label
                                nav_link {
                                  url
                                }
                              }
                            }
                          }
                        }
                      }
                      nav_link {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      allPrismicResource(
        filter: {data: {hide: {eq: false}}}
        sort: {data: {date: DESC}}
      ) {
        nodes {
          tags
          url
          data {
            description {
              text
            }
            meta_image {
              gatsbyImageData(layout: CONSTRAINED)
              alt
            }
            title {
              text
            }
            resource_title{
                richText
                text
            }
            resource_label
            resource_type
          }
          id
        }
      }
}
`

const Resource = (props) => {

    const otherTags = props.data.allPrismicResource.nodes

    const related = props.data.prismicResource.data.hide_related


    return (
        <Layout headCall={props.data.prismicHeaderCallout.data} nav={props.data.prismicNavigation.data}>
            <main className="resource" id="main">
            <SliceZone slices={props.data.prismicResource.data.body} components={components}
            context={props.data.prismicResource} />
            {related == undefined || related == false ? <section>
                <div className="wrapper gutter top">
                  <div className="relative flex justify-center p-6">
                    <div className="absolute h-1 bg-gradient-to-r from-green to-teal w-full top-10 opacity-25 rounded-full -z-10" />
                    <h2 className="px-6 bg-white font-sans">More like this</h2>
                    </div>
                    <div className="flex flex-col md:flex-row flex-wrap justify-center gap-8">
                    {otherTags
                      .filter(rel => {
                        return (
                          rel.url !== props.data.prismicResource.url &&
                          rel?.data?.resource_label &&
                          props.data?.prismicResource?.data?.resource_label &&
                          rel.data.resource_label.toLowerCase() === props.data.prismicResource.data.resource_label.toLowerCase()
                        );
                      })
                      .slice(0, 3)
                      .map((check, index) => {
                          
                            return (
                                <Link key={index} to={check.url} className="card">
                                    <span>
                                        <span className="relative block">
                                            <GatsbyImage image={getImage(check.data.meta_image)} alt={check.data.meta_image.alt ? check.data.meta_image.alt : check.data.resource_title.text} className="rounded-t-lg" />
                                            <div className="bottom-7 left-7 absolute bg-black bg-opacity-60 inline-block pr-1 pl-2 pt-1 pb-1 rounded font-bold uppercase tracking-widest text-vs text-white">{check.data.resource_label}</div>
                                        </span>
                                        <span className="p-7 block">
                                            <span className="title text-xl font-bold mb-3 pr-6 block leading-tight"><PrismicRichText field={check.data.resource_title.richText} /></span>
                                            <p className="mb-0">{check.data.description.text}</p>
                                        </span>
                                    </span>
                                    <span className="pb-7 pr-7 pl-7 block">
                                        <span className="btn bg-teal">Learn more</span>
                                    </span>
                                </Link>
                            )})}
                    </div>
                    <div className="gutter bot sm flex justify-center items-center">
                        <Link to="/resources" className="btn bg-grey text-lg pr-8 pl-5">View all resources</Link>
                    </div>
                </div>
            </section> : ''}
            </main>
        </Layout>
    );
}

export default Resource;

export const Head = (props) => {

  const label = props.data.prismicResource.data.resource_label
    const fl = label.charAt(0)
    const flCap = fl.toUpperCase()
    const rl = label.slice(1)
    const fixedLabel = flCap + rl

  const schema = {
    "@context": "https://schema.org",
    "@type": "DigitalDocument",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://quantum-health.com" + props.data.prismicResource.url + '/'
    },
    "headline": props.data.prismicResource.data.title.text,
    "description": props.data.prismicResource.data.description.text,
    "image": props.data.prismicResource.data.meta_image.url,  
    "author": {
      "@type": "Organization",
      "name": "Quantum Health"
    }
  }

return <Seo hide={props.data.prismicResource.data.hide} title={(fixedLabel) + ': ' + (props.data.prismicResource.data.title.text) + ' - Quantum Health'} desc={props.data.prismicResource.data.description.text} metaImage={props.data.prismicResource.data.meta_image.url} url={props.data.prismicResource.url} schemaMarkup={schema} />}
